import { ErrorMessage } from '@hookform/error-message'
import { Flex, Typography, Form, Tooltip } from 'antd'
import { Controller } from 'react-hook-form'
import { colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'
import './index.scss'
import CustomSelect from 'src/app/shared/components/common/select'
import { useWindowSize } from 'src/app/shared/hooks/useWindowSize'
interface IProps {
  title: string
  placeholder: string
  options: any[]
  selectName: string
  defaultSelectedValue: string
  control: any
  errors: any
  clearErrors: any
  trigger: any
  setValue: any
  onSelectChange?: any
  onSelectBlur?: any
  loading?: boolean
}
const SelectCpn = (props: IProps) => {
  const {
    title,
    placeholder,
    options,
    selectName,
    defaultSelectedValue,
    control,
    errors,
    trigger,
    onSelectChange,
    onSelectBlur,
    loading,
  } = props

  const { mode } = useWindowSize()
  const filterOption = (input: string, option?: any) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  return (
    <Flex vertical>
      <Form.Item label={title} className='isRequired label16' style={{ height: 0, margin: 0, flex: 1 }} />
      <Flex
        align='flex-start'
        justify='space-between'
        style={{
          border: `1px solid ${colorBorderDisabled}`,
          padding: '20px',
          borderRadius: '16px',
          marginBottom: 24,
          flexDirection: mode === 'mobile' ? 'column' : undefined,
          gap: mode === 'mobile' ? 12 : undefined,
        }}
      >
        <Flex vertical style={{ width: '100%' }}>
          <Controller
            name={selectName}
            control={control}
            render={({ field, fieldState }) => (
              <CustomSelect
                {...field}
                maxTagCount='responsive'
                options={loading ? [] : options}
                status={fieldState.error ? 'error' : ''}
                placeholder={placeholder}
                defaultValue={defaultSelectedValue}
                onChange={(e) => {
                  field.onChange(e)
                  onSelectChange && onSelectChange(e)
                  onSelectBlur && onSelectBlur()
                }}
                onSelect={() => {
                  trigger(selectName)
                  onSelectBlur && onSelectBlur()
                }}
                onDeselect={() => {
                  trigger(selectName)
                  onSelectBlur && onSelectBlur()
                }}
                maxTagPlaceholder={(omittedValues) => (
                  <Tooltip title={omittedValues.map(({ label }) => label).join(', ')}>
                    <span>+{omittedValues?.length}</span>
                  </Tooltip>
                )}
                showSearch
                filterOption={filterOption}
                onBlur={onSelectBlur}
                loading={loading}
                placement='topLeft'
              />
            )}
          />
          <Typography className='error-message'>
            <ErrorMessage errors={errors} name={selectName} />
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default SelectCpn
